enum ApdexEventName {
    IN_PROJECT_SEARCH = 'in-project-search',
    DASHBOARD_SEARCH = 'dashboard-search',
    TM_GET_SUGGESTIONS = 'tm-get-suggestions',
    GLOSSARY_GET_SUGGESTIONS = 'glossary-get-suggestions',
    MT_GET_SUGGESTIONS = 'mt-get-suggestions',
    CONFIRMED_STATUS_UPDATE_ON_TRANSLATION_SAVE = 'confirmed-status-update-on-translation-save',
    CONFIRMED_STATUS_UPDATE_ON_ICON_CLICK = 'confirmed-status-update-on-icon-click-translation-save',
}

enum ApdexEventType {
    BEGIN = 'begin',
    SEND_REQUEST = 'send-request',
    RESPONSE_RECEIVED = 'response-received',
    RENDERED = 'rendered',
}

export { ApdexEventName, ApdexEventType };
